module.exports = __webpack_public_path__ + "img/calendar_star.9650942f.svg";